import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './core/home/home.component';
import {CountryDetailsComponent} from './shared/countries/country-details/country-details.component';
import {ChartViewComponent} from './core/chart-view/chart-view.component';
import {ErrorComponent} from './shared/error/error.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'country/:name',
    component: CountryDetailsComponent,
  },
  {
    path: 'charts',
    component: ChartViewComponent,
  },
  {
    path: 'vaccines',
    loadChildren: () => import('./core/vaccines/vaccines.module').then(m => m.VaccinesModule)
  },
  {
    path: 'therapeutics',
    loadChildren: () => import('./core/therapeutics/therapeutics.module').then(m => m.TherapeuticsModule)
  },
  {
    path: '**',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
